/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Request_CaptionInputs */

const en_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, posted to this endpoint.`)
};

const zh_hans1_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON，POST 到这个接口。`)
};

const pt_br2_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, enviado via POST para este endpoint.`)
};

const es_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, enviado por POST a este endpoint.`)
};

const fr_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, envoyé à cet endpoint.`)
};

const de_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, per POST an diesen Endpoint gesendet.`)
};

const ru_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, отправляется на этот эндпоинт.`)
};

const it_endpoint_reference_request_caption = /** @type {(inputs: Endpoint_Reference_Request_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON, inviato a questo endpoint.`)
};

/**
* | output |
* | --- |
* | "JSON, posted to this endpoint." |
*
* @param {Endpoint_Reference_Request_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_request_caption = /** @type {((inputs?: Endpoint_Reference_Request_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Request_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_request_caption(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_request_caption(inputs)
	if (locale === "es") return es_endpoint_reference_request_caption(inputs)
	if (locale === "fr") return fr_endpoint_reference_request_caption(inputs)
	if (locale === "de") return de_endpoint_reference_request_caption(inputs)
	if (locale === "ru") return ru_endpoint_reference_request_caption(inputs)
	if (locale === "it") return it_endpoint_reference_request_caption(inputs)
	return en_endpoint_reference_request_caption(inputs)
});